import React, { useEffect, useState } from "react";
import { getScheduleStatus } from "../../../../services/admin";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { removeQueryParams, setQueryParams } from "../../../../utils/helpers";

export default function ScheduleStatus() {
    //query params
    const [searchParams, setSearchParams] = useSearchParams();
    const status = searchParams.get("view");
    const searchVal = searchParams.get("search");
    const searchName = searchParams.get("searchName");
    const screen_Name = searchParams.get("screen_Name");
    const page = searchParams.get('page');
    const rowperpage = searchParams.get('rowperpage');
    const level = searchParams.get('level');
    const [state, setState] = useState([]);
    const [userId, setUserId] = useState('')

    //query state
    const [queryValue, setQueryValue] = useState('');
    const navigate = useNavigate();
    const [query1, setQuery1] = useState('');
    const [query2, setQuery2] = useState('');
    const [query3, setQuery3] = useState('');
    const [query4, setQuery4] = useState('');
    const [query5, setQuery5] = useState('');
    const [query6, setQuery6] = useState('');
    const [levels ,setLevels] = useState('');
    const params = useParams();
    useEffect(() => {
        setUserId(params.id);
        getScheduleStatus(params.id)
            .then((data) => {
                setState(data.data.data);
            })
            .catch(() => { });

        setQueryParams(setQueryValue, setQuery1, setQuery2, setQuery3, setQuery4, setQuery5, setQuery6, status, searchVal, searchName, page, rowperpage, "", "")
        setTimeout(() => {
            // removeQueryParams()

        }, 2000);
    }, [params]);

    return (
        <div className="d-flex justify-content-end gap-10 flex-wrap bottomClass">
            <div class="back-btn-profile">
                <div onClick={() => navigate(`/mediums?view=${queryValue}&search=${query1}&searchName=${query2}&page=${query3}&rowperpage=${query4}&pagintion=${'change'}`)} className="bac-href pointer">
                    <img
                        className="bac-img"
                        src="/images/arrow-back.png"
                        alt="back"

                    />
                    Go Back
                </div>
            </div>
            <div className="middle-screen-name w-100 font-size-22">
                {" "}
                <b>{screen_Name}&nbsp;Profile</b>
            </div>
            <div className="table-box-medium">
                <table className="caseTable schedule-status-item-table">
                    <tbody>
                        <tr className="dark">
                            <th className="">Service Name</th>

                            <th className="text-center">Schedule added</th>
                        </tr>
                      
                        {state.map((item) => (
                            <tr className={`innr pointer ${item.is_schedule === 0 ? '' : 'schedule-status-item-active' }`}>
                                <td className="p-3 schedule-status-item"><Link  to={`/services?schedule=schedule&id=${userId}&view=0&level=${level}&search=${searchVal}&searchName=${searchName}&page=${page}&rowperpage=${rowperpage}`}> {item.service_name}</Link></td>
                                <td className="capitalize p-3 text-center">{item.is_schedule === 0 ? 'No' : 'Yes'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
